<div class="subcategory-selection-container" *ngIf="selectedCategory">
    <div class="request-category-title">
        <h2>{{ 'request_v2.location-selection.category-title' | translate }}</h2>
    </div>

    <div class="selected-category-container">
        <div class="selected-category-display">
            <i [class]="(selectedCategory.icon || 'icon-map-marker') + ' category-icon'"></i>
            <div class="category-content">
                <h3 class="category-title">{{ selectedCategory.name }}</h3>
            </div>
        </div>
    </div>

    <div class="dialog-title-section">
        <h2 class="dialog-title">{{ 'request_v2.subcategory-selection.title' | translate }}</h2>
    </div>

    <div class="search-container">
        <div class="search-input-wrapper">
            <i class="search-icon icon-search"></i>
            <input
                type="text"
                class="search-input"
                [(ngModel)]="searchQuery"
                (ngModelChange)="onSearchChange()"
                placeholder="{{ 'request_v2.category-selection.search-placeholder' | translate }}"
                aria-label="Search subcategories"
            />
        </div>
    </div>

    <div class="subcategories-container">
        <div
            *ngFor="let subcategory of filteredSubcategories"
            class="subcategory-item"
            [ngClass]="{ selected: subcategory.selected }"
            (click)="selectSubcategory(subcategory)"
            [attr.aria-selected]="subcategory.selected"
            [attr.tabindex]="0"
            role="option"
        >
            <h3 class="subcategory-title">{{ subcategory.name }}</h3>
        </div>

        <div class="no-results" *ngIf="filteredSubcategories.length === 0 && !loading">
            <h3 class="no-results-title">{{ 'request_v2.category-selection.no-results.title' | translate }}</h3>
            <p class="no-results-description">{{ 'request_v2.category-selection.no-results.description' | translate }}</p>
        </div>
    </div>

    <!-- TODO: When request promotions are available -->
    <!-- <div class="request-promotion-card">
    <div class="request-promotion-image">
      <img src="" alt="Maintenance report">
    </div>
    <div class="request-promotion-content">
      <h3 class="request-promotion-title">{{ 'request_v2.location-selection.promotion.title' | translate }}</h3>
      <p class="request-promotion-text">{{ 'request_v2.location-selection.promotion.description' | translate }}</p>
    </div>
  </div> -->
</div>
